<template>
    
    <!-- Encabezado de la aplicación -->
    <div class="appHeader no-border">
        <div class="left">
            <a href="#" class="headerButton goBack">
                <ion-icon name="chevron-back-outline"></ion-icon>
            </a>
        </div>
        <div class="pageTitle">
            Verificación de cancelacion
        </div>
        <div class="right"> </div>
    </div>
    <!-- * Encabezado de la aplicación -->

    <!-- Cápsula de la aplicación -->
    <div id="appCapsule">
        <div class="section" v-if="record != null">
            <div class="splash-page mt-5 mb-5">

                <div class="transfer-verification">
                    <div class="transfer-amount">
                        <span class="caption">Cantidad</span>
                        <h2>{{ record.amount }} {{ record.asset.currency.symbol }}</h2>
                    </div>
                    <div class="from-to-block mb-5">
                        <div class="item text-start">
                          <img src="@/assets/logo-b.png" alt="avatar" class="imaged w48">
                            <strong>Blocking</strong>
                        </div>
                        <div class="item text-center">
                            <img :src="record.asset.currency.image" alt="avatar" class="imaged w48">
                            <strong>{{ record.asset.currency.symbol }}</strong>
                        </div>
                        <div class="arrow"></div>
                    </div>
                </div>
                <h2 class="mb-2 mt-2">Verifique la cancelacion del bloqueo</h2>
                <p>
                    Tenias bloqueandos <strong class="text-primary">{{ record.amount }} {{ record.asset.currency.symbol }} </strong> x {{ record.lockDetails.potentialWithdrawal }} {{ record.asset.currency.symbol }}.<br>¿Está seguro?
                </p>
            </div>
        </div>
        
        <li class="active placeholder-glow" v-else>
            <a class="item placeholder col-12">
            <div class="icon-box bg-secondary">
                <p class="placeholder image-block imaged w48"></p>
            </div>
            <div class="in">
                <div>
                <div class="mb-05">
                    <strong class="placeholder col-12"></strong>
                </div>
                <div class="text-small mb-05 placeholder col-12"> <b class="placeholder col-12"></b></div>
                <div class="text-xsmall placeholder col-12"></div>
                </div>
                <span class="badge badge-primary badge-empty placeholder col-12"></span>
            </div>
            </a>
        </li>
        

        <div class="fixed-bar">
            <div class="row">
                <div class="col-6">
                    <router-link to="/" class="btn btn-lg btn-outline-secondary btn-block">Cancelar</router-link>
                </div>
                <div class="col-6">
                    <button @click="aproveBlocking" :disabled="sending" class="btn btn-lg btn-primary btn-block">Confirmar</button>
                </div>
            </div>
        </div>
        

    </div>
    <!-- * Cápsula de la aplicación -->
</template>

<script>
import { mapActions, mapState } from 'vuex';
export default {
  name: 'HomeView',
  data() {
    return {
      // networks: [],
      sending: true,
      record: null,
      options: {
        fee: [
          {
            name: '1 minuto',
            description: 'Gana hasta el 1% (Solo desarrollo)',
            type_fee: 'percentage',
            fee: '1',
            time_lock: 1,
          },
          {
            name: '2 minutos',
            description: 'Gana hasta el 1% (Solo desarrollo)',
            type_fee: 'percentage',
            fee: '1',
            time_lock: 2,
          },
          {
            name: '24 Horas',
            description: 'Gana hasta el 1-2% en 24 horas',
            type_fee: 'percentage',
            fee: '1',
            time_lock: 1440,
          },
          {
            name: '48 Horas',
            description: 'Gana hasta el 3.5-4.5% en 48 horas',
            type_fee: 'percentage',
            fee: '3',
            time_lock: 2880,
          },
          {
            name: '72 Horas',
            description: 'Gana hasta el 6-7% en 72 horas',
            type_fee: 'percentage',
            fee: '6',
            time_lock: 4320,
          },
        ]
      }
    };
  },
  watch: {
  },
  computed: {
    ...mapState(['userData', 'balance', 'last', 'networks', 'currencies']),
    // time_lock() {
    //     return this.$root.convertirTiempo(this.$route.params.time_lock);
    // },
  },
  async mounted() {
    this.$root.loadBackButtom();
    this.$root.loadInputs();
    
    const record = await this.v1_historyView({ tx_id: this.$route.params.tx_id })
    console.log('record', record)
    this.record = record;
    this.sending = false
  },
  methods: {
    ...mapActions(['newNotification', 'v1_cancelTx', 'v1_historyView']),
    /* eslint-disable */
    async aproveBlocking() {
      const self = this
      console.log('aproveBlocking', this.asset)
      this.sending = true

      self.$swal.fire({
        title: "Verificacion",
        html: `Esta cancelando un bloqueo de <strong class="text-primary">${self.record.amount} ${self.record.asset.currency.symbol} </strong>.<br>¿Está seguro?`,
        // input: "text",
        inputAttributes: {
            autocapitalize: "off"
        },
        // showCancelButton: true,
        confirmButtonText: "Si, continuar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,
        preConfirm: async (login) => {
            console.log('preConfirm', login)
            try {

              const response = await this.v1_cancelTx({ tx_id: this.$route.params.tx_id })
              console.log('response', response)
              if (response == true) {
                let timerInterval;
                return self.$swal.fire({
                  icon: "success",
                  title: "Bloqueo Cancelado!",
                  html: "Espere mientras te redireccionamos <b></b> millisegundos.",
                  timer: 5000,
                  timerProgressBar: true,
                  didOpen: () => {
                      self.$swal.showLoading();
                      const timer = self.$swal.getPopup().querySelector("b");
                      timerInterval = setInterval(() => {
                      timer.textContent = `${self.$swal.getTimerLeft()}`;
                      }, 100);
                  },
                  willClose: () => {
                      clearInterval(timerInterval);
                  }
                  }).then((result) => {
                  if (result.dismiss === self.$swal.DismissReason.timer) {
                      location.replace("/")
                  }
                });
              } else {
                  this.sending = false
              }
            
              return false;
            } catch (error) {
                console.log('error:preConfirm', error)
                self.$swal.showValidationMessage(`Error: ${error}`);
            }
        },
        allowOutsideClick: () => !self.$swal.isLoading()
      }).then(async (result) => {
        self.sending = false;
        if (result.isConfirmed) {
            setTimeout(()=>{
                location.replace("/")
            }, 5000)
        }
      });
      return false;
    },
  },
}
</script>